import * as yup from "yup";

// Step 1 — validated against pickerFormValues (FleetVehicleEditFormValues).
// All three IDs are validated so VehiclePickerForm surfaces an error on the
// always-visible manufacturer dropdown, then model, then type as the user
// progresses (the model/type error display is gated behind the prior selection).
export const CALCULATION_PICKER_SCHEMA = yup.object().shape({
  vehicleManufacturerId: yup
    .string()
    .nullable()
    .required("Molimo Vas da odaberete marku vozila"),
  vehicleModelId: yup
    .string()
    .nullable()
    .required("Molimo Vas da odaberete model vozila"),
  vehicleTypeId: yup
    .string()
    .nullable()
    .required("Molimo Vas da odaberete tip vozila"),
});

// Step 2 — validated against formValues (CalculationEditFormValues)
export const CALCULATION_PERIOD_SCHEMA = yup.object().shape({
  rentMonths: yup
    .number()
    .min(12, "Period mora biti između 12 i 60 mjeseci")
    .max(60, "Period mora biti između 12 i 60 mjeseci")
    .required("Molimo Vas da odaberete period"),
  rentKm: yup
    .number()
    .min(5000, "Kilometraža mora biti između 5.000 i 180.000 km")
    .max(180000, "Kilometraža mora biti između 5.000 i 180.000 km")
    .required("Molimo Vas da odaberete kilometražu"),
});

// Step 3 — validated against formValues before saving / requesting an offer
export const CALCULATION_NAME_SCHEMA = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required("Molimo Vas da unesete naziv kalkulacije"),
});
